import api from 'services/api/api';

export const getTicketMedio = async () => {
	const response = await api.get('/ticketMedio');
	return response.data;
};

export const getPrecoMedio = async () => {
	const response = await api.get('/ticketMedio');
	return response.data;
};

export const getTicketMedioById = async ({ queryKey }) => {
	const [, id] = queryKey;
	const url = `/ticketMedio/ticketMedioById?id=${id}`;
	const response = await api.get(url);
	return response.data;
};

// adequação do nome da requisição de consulta
export const getAverageTicketById = async ({ queryKey }) => {
	const [, id] = queryKey;
	const url = `/ticketMedio/ticketMedioById?id=${id}`;
	const response = await api.get(url);
	return response.data;
};
